module.exports = __webpack_public_path__ + "static/media/J3.e7855c30.jpg";